<template>
    <div class="value-field" :style="{ opacity: Hide ? 0 : 1 }">
        <div class="icon" :class="IconClass"></div>
        <div class="property-name" v-html="T(TKey)"></div>
        <div class="property-value">${{ ValueText }}</div>
    </div>
</template>
  
<script lang="ts">
import { T } from '@/App.vue';
import Vue from 'vue';

export default Vue.extend({
    name: 'ValueField',
    props: {
        TKey: String,
        Value: Number,
        Hide: Boolean,
        AlwaysShowValue: Boolean,
        IconClass: String,
    },
    methods: {
        T(key: string): string {
            return T(key);
        }
    },
    computed: {
        ValueText: {
            get(): string {
                if (this.Value <= 0 && !this.AlwaysShowValue) {
                    return "0";
                }
                return (this.Value * 1000).toLocaleString('en-US');
            }
        }
    }
});
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.icon {
    position: absolute;
    top: 3px;
    left: -16.18px;
    width: 37px;
    height: 37px;
    background-size: cover !important;
}

.icon-property-value {
    background: url('../assets-fca/UI/icon_property_value.svg');
}

.icon-total-worth {
    background: url('../assets-fca/UI/icon_total_worth.svg');
}

.value-field {
    height: 44px;
    width: 165.96px;
    background-color: #BFBEA5;
    margin-bottom: 12px;
    position: relative;
    border-radius: 8px;
}

.property-name {
    height: 12px;
    color: #636252;
    font-family: Rubik;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0;
    position: absolute;
    top: 4.65px;
    left: 27.03px;
    line-height: 15px;
}

.property-value {
    height: 22px;
    width: 93px;
    color: #636252;
    font-family: Rubik;
    font-size: 18px;
    font-weight: 800;
    letter-spacing: 0;
    position: absolute;
    top: 16.97px;
    left: 27.03px;
    line-height: 27px;
}
</style>
  